module.exports = __webpack_public_path__ + "./vendor-data/ba.svg";